var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-table',{attrs:{"bordered":"","dataSource":_vm.list,"pagination":false}},[_c('a-table-column',{attrs:{"title":"文件名"},scopedSlots:_vm._u([{key:"default",fn:function(text){return [_c('a',{attrs:{"href":text.completePath,"target":"_blank"}},[_vm._v(" "+_vm._s(text.name)+" ")])]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }